import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from 'vue'
import VeeValidate from 'vee-validate';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'
import 'vue-material/dist/theme/default.css';
import 'vue-bootstrap-typeahead/dist/VueBootstrapTypeahead.css'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import App from './app.vue'
import router from './router';
import {VTooltip} from "v-tooltip";

Vue.use(VueMaterial);
Vue.use(BootstrapVue);
Vue.use(VeeValidate);
Vue.use(Loading);
Vue.directive('tooltip', VTooltip);

import VueTranslate from 'vue-translate-plugin';
import Translate from '@/plugins/translate';
Vue.use(VueTranslate);
Vue.use(Translate);
import store from "./store";
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
